module.exports = __webpack_public_path__ + "img/09_Elbphilharmonie_iPad_L.5ac445a8.jpg";